<script>
	import { onMount } from 'svelte';
	import Spinner from './components/Spinner.svelte';
	import { refreshCounter } from './wishlist';

	let products = [];
	let form;
	let isLoading = false;
	let isProcessing = false;
	let isSuccess = null;

	let formInputs = {
		name: '',
		company: '',
		email: '',
		phone: '',
		street: '',
		zipcode: '',
		city: '',
		extra: '',
	}

	onMount(async () => {
		const storage = localStorage.getItem('products')
		const ids = JSON.parse(storage).map(product => product.id);
		console.log(ids)

		if (JSON.parse(storage).length > 0) {
			isLoading = true

			let formData = new FormData();
			formData.append('action', 'localStorage')
			formData.append('products', JSON.stringify(ids))

			try {
				let response = await fetch(digi_object.ajax_url, {
					method: 'POST',
					body: formData
				})

				let results = await response.json()

				products = results.products
				form = results.form

				isLoading = false;
			} catch (error) {
				console.error(error)
			}
		}

	})

	const submit = async () => {
		isProcessing = true;
		let formData = new FormData();

		let productList = products.map((product) => {
			return product.title
		});

		const productIds = products.map((product) => product.id).join(',');

		formData.append('input_1', formInputs.name)
		formData.append('input_5', formInputs.company)
		formData.append('input_2', formInputs.email)
		formData.append('input_3', formInputs.phone)
		formData.append('input_12', formInputs.street)
		formData.append('input_13', formInputs.zipcode)
		formData.append('input_14', formInputs.city)
		formData.append('input_4', formInputs.extra)
		formData.append('input_7', productList.join(', '))
		formData.append('input_10', productIds)

		if (getUTMSource()) {
			formData.append('input_11', getUTMSource())
		}

		const options = {
			method: 'POST',
			headers: {
				'X-WP-Nonce': digi_object.nonce
			},
			body: formData
		}

		try {
			let response = await fetch(digi_object.gravity_url, options)
			let data = await response.text()
			isSuccess = true
			window.location.href = "https://www.digibord-shop.nl/bedanktpagina-offerte/"
		} catch (error) {
			console.error(error)
		}

		isProcessing = false;
	}

	function getUTMSource() {
		const item = localStorage.getItem("utm_source");
		if (item) {
			return item;
		} else {
			return null;
		}
	}

	function removeFromStorage(e) {
		let product_id = parseInt(e.target.getAttribute('data-product_id'))
		e.target.parentElement.parentElement.remove()
		let liked;

		if (localStorage.getItem('products') != null) {
			liked = JSON.parse(localStorage.getItem('products'));
		} else {
			liked = [];
		}

		const index = liked.indexOf(product_id)

		if (index === -1) {
			// liked.push(product_id)
		} else {
			liked.splice(index, 1)
			products.splice(index, 1)
		}

		let json = JSON.stringify(liked);

		localStorage.setItem('products', json)
		refreshCounter()
	}
</script>

{#if products.length > 0}
	<table class="shop_table s shop_table_responsive cart woocommerce-cart-form__contents" cellspacing="0">
		<thead>
			<tr>
				<th class="product-remove">&nbsp;</th>
				<th class="product-thumbnail">&nbsp;</th>
				<th class="product-name">Product</th>
				<th class="product-price">Prijs</th>
			</tr>
		</thead>
		<tbody>
			{#each products as product }
				<tr class="woocommerce-cart-form__cart-item cart_item">

					<td class="product-remove">
						<a on:click={removeFromStorage} data-product_id={product.id} class="remove-quote">×</a>
					</td>

					<td class="product-thumbnail">
						{@html product.image }
					</td>
					<td class="product-name" data-title="Product">
						<a href="{product.link}">{ product.title }</a>
					</td>

					<td class="product-price" data-title="Prijs">
						<span class="woocommerce-Price-amount amount"><span class="woocommerce-Price-currencySymbol">€ </span>{ product.price }</span>
					</td>
				</tr>
			{/each}
		</tbody>
	</table>

	{#if !isProcessing}
		{#if isSuccess === null}
			<div class="form">
				<form on:submit|preventDefault={submit}>
					<div class="form-row-half">
						<div class="input">
							<label for="naam">Naam <span>*</span></label>
							<input type="text" name="naam" bind:value={formInputs.name} required>
						</div>
						<div class="input">
							<label for="bedrijf">Bedrijfsnaam</label>
							<input type="text" name="bedrijf" bind:value={formInputs.company}>
						</div>
					</div>
					<div class="form-row-half">
						<div class="input">
							<label for="email">E-mailadres <span>*</span></label>
							<input type="email" name="email" bind:value={formInputs.email} required>
						</div>
						<div class="input">
							<label for="telefoon">Telefoon <span>*</span></label>
							<input type="text" name="telefoon" bind:value={formInputs.phone} required>
						</div>
					</div>
					<div class="form-row-full">
						<div class="input">
							<label for="street">Straat + huisnummer</label>
							<input type="text" name="street" bind:value={formInputs.street} required>
						</div>
					</div>
					<div class="form-row-half">
						<div class="input">
							<label for="zipcode">Postcode <span>*</span></label>
							<input type="text" name="zipcode" bind:value={formInputs.zipcode} required>
						</div>
						<div class="input">
							<label for="city">Woonplaats <span>*</span></label>
							<input type="text" name="city" bind:value={formInputs.city} required>
						</div>
					</div>
					<div class="form-row-full">
						<div class="input">
							<label for="opmerkingen">Aanvullende opmerkingen</label>
							<textarea name="opmerkingen" bind:value={formInputs.extra}></textarea>
						</div>
					</div>
					<div class="form-row-half cta">
						<button>Verzenden</button>
					</div>
				</form>
			</div>
		{:else}
			<div>
				Uw offerte aanvraag is verzonden!
			</div>
		{/if}
	{:else}
		<div>
			<Spinner />
		</div>
	{/if}
{:else}
	{#if isLoading}
		<Spinner />
	{:else}
		<h2>Geen producten gevonden</h2>
	{/if}
{/if}

<style>
	.form-row-half {
		display: grid;
		grid-template-columns: 50% 50%;
		margin-bottom: 20px;
	}
	.form-row-half button {
		width: 50%;
		background: #66caea !important;
		text-transform: inherit;
		font-weight: 500;
		font-size: 16px;
		line-height: 2 !important;
		border-radius: 5px;
		box-shadow: 3px 3px rgba(34,34,34,.5) !important;
	}
	.form-row-half .input:first-child {
		padding-right: 10px;
	}
	.form-row-half .input:last-child {
		padding-left: 10px;
	}
	.form-row-full {
		display: grid;
		grid-template-columns: 100% 100%;
		margin-bottom: 20px;
	}
	input {
		border-radius: 0;
	}
	textarea {
		border-radius: 0;
	}

	@media only screen and (max-width: 900px) {
		.cta { display: block !important; }
	}
</style>
